// extracted by mini-css-extract-plugin
export default {"root":"DashboardLayout_root__ocBx2","main":"DashboardLayout_main__lA1mZ"};